import { render } from "./FormPage.vue?vue&type=template&id=532ccd23"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"

import "./FormPage.vue?vue&type=style&index=0&id=532ccd23&lang=css"
script.render = render

export default script